var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal-retain-" + _vm.file.idAprobacion,
      attrs: {
        id: "modal-retain-" + _vm.file.idAprobacion,
        title: "Retener documento Nº " + _vm.file.numero,
        "ok-title": "Confirmar",
        size: "lg",
        "ok-only": "",
        "no-close-on-backdrop": "",
        "data-cy": "add-step"
      },
      on: { close: _vm.cancelAction, ok: _vm.handleOk }
    },
    [
      _c("h4", { staticClass: "text-primary" }, [
        _vm._v(" Este documento no quedará disponible para suplencia ")
      ]),
      _c("form", { attrs: { "data-vv-scope": "retain-form" } }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("vs-textarea", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: true, min: 5 },
                    expression: "{required: true, min: 5}"
                  }
                ],
                staticClass: "mb-2",
                attrs: {
                  maxlength: "1000",
                  counter: "1000",
                  label: "Comentario",
                  name: "comment"
                },
                model: {
                  value: _vm.comment,
                  callback: function($$v) {
                    _vm.comment = $$v
                  },
                  expression: "comment"
                }
              }),
              _vm.errors.first("retain-form.comment")
                ? _c(
                    "div",
                    {
                      staticClass:
                        "con-text-validation span-text-validation-danger\n         vs-input--text-validation-span v-enter-to",
                      staticStyle: { height: "20px" }
                    },
                    [
                      _c("span", { staticClass: "span-text-validation" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.errors.first("retain-form.comment")) +
                            " "
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }